import Vue from 'vue';
import Vuex from 'vuex';
import user from '@/store/modules/user'
import common from '@/store/modules/common'
import series from '@/store/modules/series'
import shop from '@/store/modules/shopCart'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
		  user,
      common,
      series,
      shop
    }
})
export default store
